import {flattenConnection} from '@shopify/hydrogen';
import {Product, ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import {GraphQLConnection} from '@shopify/hydrogen/types';

export type FlattenedProduct = Omit<Product, 'variants'> & {
  variants: Array<ProductVariant>;
};

export function flattenProductConnection(
  products: GraphQLConnection<Product>,
): Array<FlattenedProduct> {
  return flattenConnection(products).map((product: Product) =>
    flattenProduct(product),
  );
}

export function flattenProduct(product: Product): FlattenedProduct {
  return {
    ...product,
    variants: flattenConnection<ProductVariant>(
      product.variants,
    ) as Array<ProductVariant>,
  };
}
